import React from 'react';
import styled from '@emotion/styled';
import {
  Button as BaseButton,
  ButtonType,
  Loader as BaseLoader,
  icons,
} from '@ublend-npm/aulaui-next';
import { breakpoints } from '../../components/GlobalStyle/GlobalStyle.styles';
import Pattern from '../../assets/pattern.svg';

export const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;

  flex-direction: column;

  @media (min-width: ${breakpoints.medium}) {
    flex-direction: row;
  }
`;

export const SpacingContainer = styled.div`
  background: var(--purple-light);

  background-image: url(${Pattern});
  background-size: 205%;
  width: 38.3%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  overflow: none;
  @media (min-width: ${breakpoints.medium}) {
    width: 61.7%;
    overflow: scroll;
  }
`;

export const MobileContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AulaLogo = styled(icons.AulaLogo)`
  width: var(--logo-width-small);
  height: var(--logo-height-small);

  margin-top: var(--spacing-xxx-large);
  margin-left: var(--spacing-x-large);

  @media (min-width: ${breakpoints.large}) {
    margin-left: var(--spacing-xxxx-large);
    margin-top: var(--spacing-xxxx-large);

    width: var(--logo-width-large);
    height: var(--logo-height-large);
  }
`;

export const EmailSentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: var(--spacing-giant);
`;

export const EmailLogo = styled.img`
  color: var(--black-opacity60);
  margin-bottom: var(--spacing-x-large);

  width: var(--email-image-width-small);
  height: var(--email-image-height-small);

  @media (min-width: ${breakpoints.large}) {
    width: var(--email-image-width-large);
    height: var(--email-image-height-large);
  }
`;

export const EmailMessage = styled.span`
  letter-spacing: 0.15px;

  font-family: var(--font);
  font-weight: var(--font-weight-semi-bold);
  font-size: var(--font-size-headline);
  line-height: var(--font-line-height-large);
  color: var(--black-opacity87);
`;

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;

  flex-direction: row;
  justify-content: space-between;

  @media (min-width: ${breakpoints.medium}) {
    min-height: 140px;
    flex-direction: row-reverse;
    justify-content: flex-start;
  }
`;

const SigninButtonWrapper = styled.div`
  margin-top: var(--spacing-x-large);
  margin-right: var(--spacing-xxx-large);
`;

export const SigninButton = (props: ButtonType) => (
  <SigninButtonWrapper>
    <BaseButton {...props} />
  </SigninButtonWrapper>
);

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingText = styled.span`
  font-family: var(--font);
  color: var(--black-opacity60);

  font-size: var(--font-size-large);
  line-height: var(--font-line-height-large);

  margin-top: var(--spacing-large);
`;

export const Loader = () => (
  <LoaderWrapper>
    <BaseLoader size={80} thickness={3.6} />
    <LoadingText>Validating your account...</LoadingText>
  </LoaderWrapper>
);

export const MessageContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;

  margin-left: var(--spacing-x-large);
  margin-right: var(--spacing-xx-large);

  margin-top: var(--spacing-xxxx-large);

  @media (min-width: ${breakpoints.medium}) {
    align-items: center;
    justify-content: center;
  }
`;
